import get from 'lodash.get';

const getValue = (batch, elementId, target, computeFallbackValue = null) => {
  const currentValue = get(batch, `${elementId}.${target}`);

  if (computeFallbackValue && !currentValue) {
    return computeFallbackValue({ elementId, target });
  }

  return currentValue;
};

const getBatchValues = (batch, { elementIds, targets, computeFallbackValue = null }) =>
  targets.map((target) => {
    if (elementIds.length > 1) {
      return elementIds
        .map((elementId) => getValue(batch, elementId, target, computeFallbackValue))
        .filter((value) => value !== undefined);
    }

    return getValue(batch, elementIds[0], target, computeFallbackValue);
  });

export default getBatchValues;
